import '@fontsource-variable/noto-sans-sc';
import './styles/main.css';
import { Game } from './core/Game';

const app = document.querySelector<HTMLElement>('#app');

if (!app) {
  throw new Error('找不到 #app 容器');
}

const game = new Game(app);

if (import.meta.hot) {
  import.meta.hot.dispose(() => game.dispose());
}
